@if (selectedProcess().category) {
  <mat-label
    style="cursor: pointer; padding-left: 5px;"
    (click)="onCategoryClicked(selectedProcess().category)"
  >
    {{ CartStatuses.get(selectedProcess().category).label }}
  </mat-label>
}
@if ( selectedProcess().state || selectedProcess().state === 0) {
  <mat-label
    style="cursor: pointer"
    (click)="onStateClicked(selectedProcess().state)"
  >
    / {{ stateFilterToLabelMap.get(selectedProcess().state) }}
  </mat-label>
}
@if (selectedInvoice()) {
  <mat-label
    style="cursor: pointer"
    (click)="onCartFilterObjClicked()"
  >
    / {{ (selectedInvoice().invoiceId) }}
  </mat-label>
}
@if (selectedClient()) {
  <mat-label
    style="cursor: pointer"
    (click)="onCartFilterObjClicked()"
  >
    / {{ (selectedClient().name) || 'Unbenannter Patient' }}
  </mat-label>
}
@if (selectedCart()?.number) {
  <mat-label>
    / {{ selectedCart().number }}
  </mat-label>
}

<!--<lib-help-icon style="width: 1rem; height: 1rem" (click)="showHelpForBreadcrumb()"/>-->
